_ref$followRedirect